import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authSlice";
import tradeReducer from "./reducers/tradeSlice";
import borrowerReducer from "./reducers/borrowerSlice";
import loansReducer from "./reducers/loansSlice";
import tradeDetailReducer from "./reducers/trade_details_Slice";
import tradeDetailByIdReducer from "./reducers/tradeDetail_byId_slice";
import dispatchDetailReducer from "./reducers/dispatchDetail_slice";
import arrivalDetailsReducer from "./reducers/arrivalDetails_slice";
import paymentDetailReducer from "./reducers/paymentDetails_slice";
import invoiceDetailReducer from "./reducers/invoiceDetailsSlice";
import pattiDetailReducer from "./reducers/pattiDetailsSlice";
import reportsReducer from "./reducers/reports_slice";
import customerReducer from "./reducers/customerSlice";
import loanPaymentView from "./reducers/loanPaymentViewSlice";
import marketReducer from "./reducers/marketSlice";
import loanMovePayment from "./reducers/loanMovePaymentSlice";
import payoutViewSlice from "./pages/payments/payout_view/bloc/payoutViewSlice";
import payoutsSlice from "./pages/payments/payouts/bloc/payoutsSlice";
import collectionsSlice from "./pages/payments/collections/bloc/collectionsSlice";
import cancelTradeSlice from "./reducers/cancelTradeSlice";
import partner from "./reducers/partner";
import riskEngineDetailsSlice from "./reducers/riskEngineSlice";
import beneficiarySlice from './pages/payments/beneficiaries/bloc/beneficiariesSlice'
import payoutSlice from "./pages/payments/beneficiaries/payout/payoutSlice";
import dailyPrice from './reducers/daily-price';
import cashPfUseAgreement from './reducers/cashPfUseAgreementSlice';
import financePartnerSlice from "./reducers/financePartnerSlice";
import mapPartnerSlice from "./reducers/mapPartnerSlice";
import finPartnerAgreementSlice from "./reducers/finPartnerAgreementSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    trades: tradeReducer,
    borrowers: borrowerReducer,
    loans: loansReducer,
    tradeDetails: tradeDetailReducer,
    tradeDetailsById: tradeDetailByIdReducer,
    dispatchDetails: dispatchDetailReducer,
    arrivalDetails: arrivalDetailsReducer,
    paymentDetails: paymentDetailReducer,
    invoiceDetails: invoiceDetailReducer,
    pattiDetails: pattiDetailReducer,
    customer: customerReducer,
    reports: reportsReducer,
    loanPaymentView: loanPaymentView,
    marketDetails: marketReducer,
    loanMovePayment: loanMovePayment,
    payouts: payoutsSlice,
    payoutView: payoutViewSlice,
    collections: collectionsSlice,
    cancelTrade: cancelTradeSlice,
    partner: partner,
    riskEngineDetailsSlice: riskEngineDetailsSlice,
    beneficiary: beneficiarySlice,
    payout: payoutSlice,
    dailyPrice: dailyPrice,
    cashPfUseAgreement: cashPfUseAgreement,
    financePartner: financePartnerSlice,
    mapPartner: mapPartnerSlice,
    finPartnerAgreement: finPartnerAgreementSlice
  },
});
export type TRootState = ReturnType<typeof store.getState>;
export default store;
